"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeList = mergeList;
exports.payloadError = payloadError;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// https://stackoverflow.com/questions/48208665/how-to-update-merge-array-values-in-react-redux-correctly
function mergeList(old, updated) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'uuid';
  if ((0, _typeof2.default)(updated) !== 'object' || !updated.length) return [];
  var updatedArray = (old || []).map(function (o) {
    var v = updated.find(function (u) {
      return u[key] === o[key];
    });
    if (!v) return null; // remove no longer existing

    return _objectSpread(_objectSpread({}, o), v);
  }).filter(function (n) {
    return n;
  });
  var newArray = updated.filter(function (u) {
    return !updatedArray.some(function (v) {
      return v[key] === u[key];
    });
  });
  return updatedArray.concat(newArray);
}

function payloadError(action) {
  if (!action || !action.payload || !action.payload.errors || !action.payload.errors.length) return 'Something unexpected happened';
  return action.payload.errors.join(', ');
}